// @flow

import {
  DOCUMENTS_FORM_CREATE,
  NEW_PATIENT_DOCUMENTS_FORM_CREATE,
  DOCUMENTS_FORM_CREATED,
  NEW_PATIENT_DOCUMENTS_FORM_CREATED,
  DOCUMENTS_FORM_CREATE_ERROR,
  DOCUMENTS_FORM_DELETE,
  DOCUMENTS_FORM_DELETED,
  DOCUMENTS_FORM_DELETE_ERROR,
  DOCUMENTS_FORM_UPDATE,
  DOCUMENTS_FORM_UPDATED,
  DOCUMENTS_FORM_UPDATE_ERROR
} from './constants';

import type { Action, State } from '../types';

const initialState: State = {
  createStatus: { queueInProgress: 0, queueError: 0 },
  deleteStatus: { idQueueInProgress: [], idQueueError: [] },
  updateStatus: { idQueueInProgress: [], idQueueError: [] }
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case DOCUMENTS_FORM_CREATE:
      return {
        ...state,
        createStatus: {
          ...state.createStatus,
          queueInProgress: state.createStatus.queueInProgress + 1
        }
      };
    case NEW_PATIENT_DOCUMENTS_FORM_CREATE:
      return {
        ...state,
        createStatus: {
          ...state.createStatus,
          queueInProgress: state.createStatus.queueInProgress + 1
        }
      };
    case DOCUMENTS_FORM_CREATED:
      return {
        ...state,
        createStatus: {
          ...state.createStatus,
          queueInProgress: state.createStatus.queueInProgress - 1
        }
      };
    case NEW_PATIENT_DOCUMENTS_FORM_CREATED:
      return {
        ...state,
        createStatus: {
          ...state.createStatus,
          queueInProgress: state.createStatus.queueInProgress - 1
        }
      };
    case DOCUMENTS_FORM_CREATE_ERROR:
      return {
        ...state,
        createStatus: {
          ...state.createStatus,
          queueInProgress: state.createStatus.queueInProgress - 1,
          queueError: state.createStatus.queueError + 1
        }
      };
    case DOCUMENTS_FORM_DELETE:
      return {
        ...state,
        deleteStatus: {
          ...state.deleteStatus,
          idQueueInProgress: [...state.deleteStatus.idQueueInProgress, action.id]
        }
      };
    case DOCUMENTS_FORM_DELETED:
      return {
        ...state,
        deleteStatus: {
          ...state.deleteStatus,
          idQueueInProgress: state.deleteStatus.idQueueInProgress.filter(id => id !== action.id)
        }
      };
    case DOCUMENTS_FORM_DELETE_ERROR:
      return {
        ...state,
        deleteStatus: {
          ...state.deleteStatus,
          idQueueInProgress: state.deleteStatus.idQueueInProgress.filter(id => id !== action.id),
          idQueueError: [...state.deleteStatus.idQueueError, action.id]
        }
      };
    case DOCUMENTS_FORM_UPDATE:
      return {
        ...state,
        updateStatus: {
          ...state.updateStatus,
          idQueueInProgress: [...state.updateStatus.idQueueInProgress, action.id]
        }
      };
    case DOCUMENTS_FORM_UPDATED:
      return {
        ...state,
        updateStatus: {
          ...state.updateStatus,
          idQueueInProgress: state.updateStatus.idQueueInProgress.filter(id => id !== action.id)
        }
      };
    case DOCUMENTS_FORM_UPDATE_ERROR:
      return {
        ...state,
        updateStatus: {
          ...state.updateStatus,
          idQueueInProgress: state.updateStatus.idQueueInProgress.filter(id => id !== action.id),
          idQueueError: [...state.updateStatus.idQueueError, action.id]
        }
      };
    default:
      return state;
  }
};

export default reducer;
